import React from "react";

const EmptyRiskAdjustment = () => {
  return <></>;
};

export default EmptyRiskAdjustment;
